import Layout4Admin1 from "components/layout/Layout4Admin1";
import LayoutAdmin2 from "components/layout/LayoutAdmin2";
import Css from './Customer.module.css';
import { Button, Col, Form, InputGroup, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import { ConvertDateToText, DisplayPaging } from "components/MyControl";
import { useNavigate } from "react-router-dom";
import ApiConection from "api_ref/ApiConection";
import UtilClass from "api_ref/UtilClass";

export default function ConfigTemplateEmail() {
    const navigate = useNavigate();
    const api = new ApiConection();
    const util = new UtilClass();

    const [loading, setLoading] = useState(false);
    const [dataList, setDataList] = useState([]);
    const [condition, setCondition] = useState({
    });
    const [pagination, setPagination] = useState({
        record_start: 0,
        record_end: 0,
        record_count: 0,
        page_count: 0
    })
    const [search, setSearch] = useState({
        page: util.getCombinedSessionStorage('/setting/config-template-email','page') ?? 1,
        size: util.getCombinedSessionStorage('/setting/config-template-email','size') ?? 10
    })
    const [filterDispaly, setFilterDisplay] = useState(false);

    const getData = async () => {
        let data = {
            search: {
                //name : condition,
                //data_type : "string",
                //description : condition
            },
            pagination: {
                page: search.page,
                size: search.size,
                order_by: "id",
                order_mode: "asc"
            }
        }

        if (condition.subject !== '')
            data.search.subject = condition.subject;

        setLoading(true);

        const response_paging = await api.postData(`api/ConfigTemplateEmail/pagination`, data);
        if (response_paging.status === true) {
            handleSetPagination('record_start', response_paging.data.record_start);
            handleSetPagination('record_count', response_paging.data.record_count);
            handleSetPagination('page_count', response_paging.data.page_count);

            let record_end = response_paging.data.record_start + (search.size - 1);
            if (record_end > response_paging.data.record_count) {
                record_end = response_paging.data.record_count;
            }

            handleSetPagination('record_end', record_end);
        }

        const response = await api.postData(`api/ConfigTemplateEmail/result`, data);
        setDataList(response.data);

        setLoading(false);
    }
    const handleQuickSearch = (event) => {
        const { name, value } = event.target;
        handleSetCondition('subject', value);
        handleSetSearch('page', 1);
        handleSetSearch('size', search.size);
    }

    const handleSetCondition = (name, value) => {
        setCondition(prevData => {
            return { ...prevData, [name]: value };
        });
    }

    const handleSetPagination = (name, value) => {
        setPagination(prevData => {
            return { ...prevData, [name]: value };
        });
    }
    const handleSizeTableChange = (event) => {
        const { name, value } = event.target;

        util.setCombinedSessionStorage('/setting/config-template-email','page',1);
        util.setCombinedSessionStorage('/setting/config-template-email','size',value);

        handleSetSearch('page', 1);
        handleSetSearch('size', value);
    }
    const handlePagingChange = (page_no) => {

        util.setCombinedSessionStorage('/setting/config-template-email','page',page_no);
        handleSetSearch('page', page_no);
    }
    const handleSetSearch = (name, value) => {
        setSearch(prevData => {
            return { ...prevData, [name]: value };
        });
    }

    const handleGotoDetail = (id) => {
        navigate(`${id}`);
    }

    useEffect(() => {
        getData();
    }, [])

    useEffect(() => {
        if (search !== undefined) {
            const delay = setTimeout(() => {
                // เรียกใช้ฟังก์ชันสำหรับการคำนวณผลลัพธ์ที่ต้องการ
                getData();
            }, 500);

            return () => clearTimeout(delay);
        }
    }, [search, condition])

    return (
        <Layout4Admin1 >
            <div className={Css.Graph_Box + ' w-auto d-block m-3 shadow'}>
                <div className={Css.Content}>
                    <div className={Css.Header}>
                        <div className="d-flex">
                            <h6 className="d-flex align-items-center">ตั้งค่าเนื้อความส่งอีเมล</h6>
                            <div className="flex-fill">
                                <Form.Group as={Row}>
                                    <Form.Label column sm={4} className="text-end">ค้นหา</Form.Label>
                                    <Col>
                                        <InputGroup>
                                            <Form.Control placeholder="ชื่อตัวแปร" id={'subject'} value={condition.subject}
                                                disabled={filterDispaly}
                                                onChange={(event) => handleQuickSearch(event)} />
                                            <Button variant="outline-secondary" onClick={event => setFilterDisplay(!filterDispaly)}>
                                                {
                                                    filterDispaly === true &&
                                                    <i className="fa-solid fa-arrow-up-short-wide"></i>
                                                }
                                                {
                                                    filterDispaly === false &&
                                                    <i className="fa-solid fa-arrow-down-short-wide"></i>
                                                }
                                                <span></span>
                                            </Button>
                                            <Button>
                                                <i className="fa-solid fa-magnifying-glass"></i>
                                            </Button>
                                        </InputGroup>

                                    </Col>
                                </Form.Group>
                            </div>
                        </div>
                    </div>
                    <div className="position-relative" >
                        {
                            loading &&
                            <div className="position-absolute w-100 h-100 bg-white bg-opacity-50" style={{ zIndex: 5 }}>
                                <div className="d-flex justify-content-center">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            </div>
                        }
                        <div className="table-responsive border rounded">
                            <table className="table text-nowrap mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th></th>
                                        <th className="text-start"></th>
                                        <th className="text-start">subject</th>
                                        <th className="text-start">body</th>
                                        <th className="text-start">description</th>
                                        <th className="text-start">remark</th>
                                        <th className="text-center">วันที่แก้ไข</th>
                                        <th className="text-start">ผู้แก้ไข</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        dataList?.map((obj, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <button className="btn btn-edit-icon" onClick={event => handleGotoDetail(obj.id)}>
                                                        <i className="fa-solid fa-pen-to-square"></i>
                                                    </button>
                                                </td>
                                                <td className="text-start" width={25}>{pagination?.record_start + index}</td>
                                                <td className="text-start">{obj.subject}</td>
                                                <td className="text-start">{obj.body}</td>
                                                <td className="text-start">{obj.description}</td>
                                                <td className="text-start">{obj.remark}</td>
                                                <td className="text-center">{ConvertDateToText(obj.modify_date)}</td>
                                                <td className="text-start">{obj.modify_by}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>

                        <DisplayPaging rec_start={pagination.record_start}
                            rec_end={pagination.record_end}
                            rec_count={pagination.record_count}
                            onSizeChange={handleSizeTableChange}
                            cur_page={search.page}
                            size={search.size}
                            page_count={pagination.page_count}
                            onPagingChange={handlePagingChange} />
                    </div>
                </div>
            </div>
        </Layout4Admin1>
    )
}